import React from 'react'
import { createPortal } from 'react-dom'
import { ModalClose } from '../icons'

export default function AdminModal({
  open,
  title,
  subtitle,
  onClose,
  children,
  footer,
  wide = false,
  className = '',
}) {
  if (!open || typeof document === 'undefined') return null

  return createPortal(
    <div className="admin-modal-overlay show" role="presentation" onClick={onClose}>
      <div
        className={`admin-modal admin-modal-scroll${wide ? ' admin-modal-wide' : ''}${className ? ` ${className}` : ''}`}
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal-header">
          <div>
            <h3>{title}</h3>
            {subtitle ? <p className="admin-modal-subtitle">{subtitle}</p> : null}
          </div>
          <ModalClose onClick={onClose} />
        </div>
        <div className="admin-modal-body">{children}</div>
        {footer ? <div className="admin-modal-footer">{footer}</div> : null}
      </div>
    </div>,
    document.body
  )
}
